var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-card',[_c('vs-row',{attrs:{"vs-justify":"center"}},[_c('vs-icon',{attrs:{"icon":"search","size":"large"}})],1),_c('vs-row',{attrs:{"vs-justify":"center"}},[_vm._v(" "+_vm._s(_vm.Text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }